<template>
    <router-link
        :to="route"
        :href="currentHref"
        :target="target"
    >
        {{cta.caption}}
    </router-link>
</template>

<script>
const routes = {
    project: 'Project',
    market: 'Market',
    technique: 'Technique',
    story: 'Story',
    method: 'Method'
}
export default {
    props: {
        cta: {
            type: Object,
            default() {}
        }
    },
    mounted() {
      // console.log(this.cta);
    },
    computed: {
        currentRoute() {
            if(this.cta.type === 'object') {
                if(this.cta.object.post_type === "custom-page") {
                    return {
                        name: this.cta.object.post_name,
                        params: {
                            locale: this.$route.params.locale
                        }
                    }
                } else {
                    // window.console.log(this.cta)
                    const technique = this.cta.object.related_posts.find(_ => _.type === 'technique')
                    return {
                        name: routes[this.cta.object.type],
                        params: {
                            slug: this.cta.object.customslug || this.cta.object.slug,
                            locale: this.$route.params.locale,
                            technique: technique ? technique.customslug || technique.slug : ''
                        }
                    }
                }
            } else if(this.cta.type === 'link') {
                return {
                    name: this.cta.link,
                    params: {
                        locale: this.$route.params.locale
                    }
                }
            } else if(this.cta.type === 'custompage') {
                return {
                    name: this.cta.custompage,
                    params: {
                        locale: this.$route.params.locale
                    }
                }
            } else {
                return {}
            }
        },
        currentHref() {
            if(this.cta.type === 'object' || this.cta.type === 'link' || this.cta.type === 'custompage') {
                return this.$trl(this.currentRoute).path;
            } else if(this.cta.type === 'url'){
                return this.cta.url
            } else if(this.cta.type === 'download'){
                return this.cta.file
            }
            return new Error('post type must be "object", "url" or "download"')
        },
        target() {
            if(this.cta.type === 'object' || this.cta.type === 'link' || this.cta.type === 'custompage') {
                return '_self'
            } else {
                return '_blank'
            }
        },
        route() {
          return this.$trl(this.currentRoute)
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
a
  cursor: pointer
</style>
